module.exports = __webpack_public_path__ + "static/media/PrestigePhotographywithCompanion.a992c395.svg";